import { Component, HostBinding } from '@angular/core';
import { EnvironmentService } from '../../services/environment.service';
import { PostMessageService } from '../../services/post-message.service';
import { VehicleFinanceViewComponent } from '../vehicle-finance/vehicle-finance-view/vehicle-finance-view.component';
import { CommonModule } from '@angular/common';
import { VehicleFinanceViewCredisenseComponent } from '../vehicle-finance/vehicle-finance-view-credisense/vehicle-finance-view-credisense.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-application-view',
  standalone: true,
  imports: [
    CommonModule,
    VehicleFinanceViewComponent,
    VehicleFinanceViewCredisenseComponent
  ],
  templateUrl: './application-view.component.html',
  styleUrl: './application-view.component.scss'
})
export class ApplicationViewComponent {
  @HostBinding('attr.data-env') get env() { return this.environmentService.environment(); }

  // Force using v4 as no apps should be coming through on v3 flow anymore.
  useCredisenseApp = true; 

	constructor(
		private environmentService: EnvironmentService,
		private postMessageService: PostMessageService,
    private route: ActivatedRoute
	){ }

   ngOnInit() {
    // this.route.queryParams.subscribe(params => {
    //   this.useCredisenseApp = params['type'] === '40'; // type=40 → use v4
    // });
  }
}
